import axios from "axios";
import { setAccessToken, setRefreshToken } from "lib/accessToken";
import { getFromLocalStorage } from "lib/common/helper/LocalStorage";
import { Error } from "lib/common/types/ErrorResponse";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getUser, onBoardUser } from "../../../redux/reducers/userSlice";
import { host } from "../../../utils/constants";
import { message as _message } from "antd";

function useOnboardReqWithTempToken() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useAppDispatch();
  const user = useSelector(getUser);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (error && error.message) {
      _message?.error(error.message);
    } else if (message) {
      _message?.success(message);
    }
  }, [error, message]);

  const reqWithTempToken = useCallback(
    (operation, value) => {
      setLoading(true);
      setError(null);

      const token = getFromLocalStorage("registerToken");

      axios({
        method: operation === "set_user_profile" ? "put" : "post",
        url: host + `/auth/register/${operation}`,
        data: {
          ...value,
          mobile: user?.userData?.mobile,
          token: token,
        },
      })
        .then(({ data: { data, success, message } }) => {
          setMessage(message);
          if (data) {
            setSuccess(success);
            dispatch(
              onBoardUser({
                user: { userData: { mobile: data?.mobile } },
                onBoardingStatus: data.onBoardingStatus,
              }),
            );

            {
              data.accessToken && setAccessToken(data.accessToken);
            }
            {
              data.refreshToken && setRefreshToken(data.refreshToken);
            }
          }
        })
        .catch((err) => {
          setError(err.response.data);
        })
        .finally(() => setLoading(false));
    },
    [user, dispatch],
  );

  return { reqWithTempToken, loading, error, success };
}

export default useOnboardReqWithTempToken;
